//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            description: '',
            nickname: ''
        }
    },
    props: {
        client_name: String,
        client_description: String,
        show: Boolean
    },
    watch: {
        show: {
            handler (latest, old) {
                if (latest) {
                    this.nickname = this.client_name
                    this.description = this.client_description
                }
            },
            immediate: true
        },
    },
}
